import AdBanner from "./AdBanner";

export const DisplayAdHorizontal = ({adSlot})=> {
    return (
        <div className="w-full flex justify-center px-4 py-6">
          <div className="bg-white rounded-2xl shadow-md p-4 overflow-auto">
            <AdBanner adSlot={adSlot} />
          </div>
        </div>
    )
}

export const DisplayAdVertical = ({adSlot})=> {
    return (
         <div className="w-full flex justify-center items-start px-4 py-4 overflow-x-auto">
          <div className="bg-white rounded-2xl shadow-lg p-4 inline-block">
            <AdBanner adSlot={adSlot} />
          </div>
        </div>

    )
}
export const InFeedAd = ({adSlot})=> {
    return (
         <div className="w-full px-4 py-4 flex justify-center">
          <div className="w-full max-w-full bg-white rounded-xl shadow-sm border border-gray-200 overflow-visible">
            <AdBanner
              adSlot={adSlot}
              adFormat="fluid"
              layout="in-feed"
              layoutKey="-ig+7-f-l+2u"
            />
          </div>
        </div>
    )
}
